import {Box, Container} from '@mui/material';
import type * as React from 'react';
import InterestedForm from "@/components/InterestedForm";

const Interested = (): React.ReactElement => {

    return (
        <Container maxWidth='sm'>
            <Box sx={{typography: 'h4', textAlign: 'center', mt: 3, color: '#fff'}}>
                <InterestedForm />
            </Box>
        </Container>
    );
};

export default Interested;
